export default __webpack_public_path__ + "3c54f236e4f2dbcbfb4dd485a25e2a15.js";